<template>
  <div
    v-if="isVisible"
    id="toast"
    class="toast"
    :class="{ show: isVisible }"
    role="status"
    aria-live="polite"
  >
    <span>
      <img src="../../assets/images/icon/icon_check_circle.svg" alt="" class="toast-icon" />
      {{ message }}
    </span>
    <span>
      <img
        src="../../assets/images/icon/icon_closeX_white.svg"
        alt="閉じる"
        class="toast-close"
        @click="hide"
      />
    </span>
  </div>
</template>

<script setup lang="ts">
defineOptions({ name: 'AppToast' })

import { useToast } from '@/composables/useToast'
const { isVisible, message, hide } = useToast()
</script>
